module.exports = __webpack_public_path__ + "img/BOX_book.fa90f946.png";